import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { toast } from 'sonner';

import { AuthLayout } from '@/components/layouts/AuthLayout';
import { StaffAuthBrandPanel } from '@/components/layouts/components/StaffAuthBrandPanel';
import { StaffLoginForm } from '@/features/auth/components/StaffLoginForm';

export const Route = createFileRoute('/login/')({
  component: LoginPage,
  validateSearch: (s: Record<string, unknown>) => ({
    email: typeof s.email === 'string' ? s.email : undefined,
  }),
});

function LoginPage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('reason') === 'idle') {
      toast.info('You were signed out due to inactivity.');
    }
  }, []);

  return (
    <AuthLayout brandPanel={<StaffAuthBrandPanel />} formSide="left">
      <StaffLoginForm />
    </AuthLayout>
  );
}
